import CycleMeasurement from '../../../enums/cycle-measurement';
import { SKIP_SYMBOL, TEMPERATURE_ZONE } from '../constants';

export interface IDeltaViewProps {
  value: number | string;
  currentMeasurement: CycleMeasurement;
}
export const DeltaView = ({ value: data, currentMeasurement }: IDeltaViewProps) => {
  if (typeof data === 'string') {
    return <span className="rounded px-[6px] py-[1px]">{SKIP_SYMBOL}</span>;
  }

  const temperatureZoneByMeasurement = TEMPERATURE_ZONE[currentMeasurement];

  if (temperatureZoneByMeasurement.EXTREME_COLD.MIN < data && data <= temperatureZoneByMeasurement.EXTREME_COLD.MAX) {
    return (
      <span className={`rounded px-[6px] py-[1px] text-white ${temperatureZoneByMeasurement.EXTREME_COLD.COLOR}`}>
        {data}
      </span>
    );
  }

  if (temperatureZoneByMeasurement.VERY_COLD.MIN < data && data < temperatureZoneByMeasurement.VERY_COLD.MAX) {
    return (
      <span className={`rounded px-[6px] py-[1px] text-white ${temperatureZoneByMeasurement.VERY_COLD.COLOR}`}>
        {data}
      </span>
    );
  }

  if (temperatureZoneByMeasurement.NEUTRAL.MIN <= data && data < temperatureZoneByMeasurement.NEUTRAL.MAX) {
    return <span className={`rounded px-[6px] py-[1px] ${temperatureZoneByMeasurement.NEUTRAL.COLOR}`}>{data}</span>;
  }

  if (temperatureZoneByMeasurement.WARM.MIN <= data && data < temperatureZoneByMeasurement.WARM.MAX) {
    return (
      <span className={`rounded px-[6px] py-[1px] text-white ${temperatureZoneByMeasurement.WARM.COLOR}`}>{data}</span>
    );
  }

  if (temperatureZoneByMeasurement.HOT.MIN <= data && data < temperatureZoneByMeasurement.HOT.MAX) {
    return (
      <span className={`rounded px-[6px] py-[1px] text-white ${temperatureZoneByMeasurement.HOT.COLOR}`}>{data}</span>
    );
  }
};
